import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Validators, FormGroup, FormBuilder } from "@angular/forms";

import { SoundEnum } from "src/app/enums/sound.enum";
import { ICourseType } from "src/app/interfaces/course-type";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CourseTypeService } from "./../../../../services/http/business/course-type/course-type.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-course-type-entry",
  templateUrl: "./course-type-entry.component.html",
  styleUrls: ["./course-type-entry.component.css"],
  providers: [ErrorsService]
})
export class CourseTypeEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  errors = new Array();
  compnayList: ICompany;
  isOwner: boolean;
  branchList: any;
  //selected = new FormControl();

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private branchService: BranchService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private snackBarService: SnackBarService,
    private courseTypeService: CourseTypeService,
    private dialogRef: MatDialogRef<CourseTypeEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICourseType
  ) {
   // this.selected.setValue(this.data.Branchs);
  }

  ngOnInit() {
    this.checkOwner();
    this.createForm();
    this.getBranchList();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  createForm() {

    this.form = this.fb.group({
      companyCode: [
        this.cidService.getCID(),
        Validators.compose([Validators.required])
      ],
      Title: [
        this.data && this.data.Title ? this.data.Title : null,
        Validators.compose([Validators.required, Validators.maxLength(50)])
      ],
      Branchs: [this.data && this.data.Branchs ? this.data.Branchs : null, Validators.required],
      Id: [this.data && this.data.Id ? this.data.Id : 0]
    });

  }

  comparer(o1: any, o2: any): boolean {
    return o1 === o2;
  }

  getBranchList() {
    this.branchService.list().subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  setCompanyCode(e: string) {
    this.cidService.setCID(e);
    let _this = this;
    setTimeout(function () {
      _this.getBranchList();
    });
  }

  submit(form: any) {
    this.errors = new Array();
    // debugger

    // var ls = [];
    // this.selected.value.forEach(element => {
    //   ls.push(element)
    // });
    // form.Branchs = ls;
    // debugger
    if (this.data) {
      this.courseTypeService.edit(form).subscribe(
        () => {
          this.dialogRef.close();
          this.snackBarService.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      this.courseTypeService.add(form).subscribe(
        () => {
          this.dialogRef.close();
          this.snackBarService.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }

  onNoclick() {
    this.dialogRef.close();
  }
}
